import { DistanceUnit, kmToMiles } from 'lib/geo/distanceUnits'
import { type TrendingDestination } from 'home/components/TrendingDestinations/constants'
import { buildHotelUrl } from 'home/components/TrendingDestinations/utils'
import { DESTINATION_DATA } from 'constants/recommendations'

export function getDistanceLabel(distanceKm: number, distanceFrom: string, distanceUnitOutput: DistanceUnit): string | null {
  if (distanceKm > 20) {
    return null
  }
  if (distanceUnitOutput === 'km') {
    if (distanceKm < 0.1) {
      const meters = (distanceKm * 1000).toFixed(1)
      return `${meters.replace(/\.0$/, '')}m from ${distanceFrom}`
    }

    return `${distanceKm.toFixed(1).replace(/\.0$/, '')}km from ${distanceFrom}`
  }
  if (distanceUnitOutput === 'mi') {
    const miles = kmToMiles(distanceKm)
    return `${miles.toFixed(1).replace(/\.0$/, '')} mi from ${distanceFrom}`
  }
  return null
}

/**
 * Converts an array of recommended destinations into an array of trending destinations.
 * Deduplicates destinations based on destination names and filters out invalid destinations.
 *
 * @param {Array<App.RecommendationDestination>} destinations - An array of recommended destination objects.
 * @returns {Array<TrendingDestination>} An array of trending destination objects, each containing valid `name`, `imageId`, `url`, and `destinationId` properties.
 */
export function lereRecommendedDestinationsToTrendingDestinations(destinations: Array<App.RecommendationDestination>): Array<TrendingDestination> {
  const dedupedDestinations: Array<App.RecommendationDestination> = []
  const seenNames = new Set<string>()
  for (const destination of destinations) {
    const name = DESTINATION_DATA[destination.destinationId]?.name
    if (name && !seenNames.has(name)) {
      seenNames.add(name)
      dedupedDestinations.push(destination)
    }
  }

  return dedupedDestinations.map(({ destinationId }) => {
    const name = DESTINATION_DATA[destinationId]?.name
    const imageId = DESTINATION_DATA[destinationId]?.imageId
    const url = name ? buildHotelUrl(name, destinationId) : undefined
    const isValid = !!name && !!imageId && !!url

    return isValid ? ({
      name,
      imageId,
      url,
      destinationId,
    }) : undefined
  }).filter(d => !!d)
}
